import { customElement, bindable, useView, bindingMode, autoinject, containerless, PLATFORM, observable } from 'aurelia-framework';
import { InputBase } from '../inputBase';

@customElement('form-input-bool')
@autoinject()
export class FormInputBool extends InputBase<string> {
    @bindable disabled: boolean = false;
}
